import { Academics, Major, Path } from '../../lib/types';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../../components/ui/tabs';
import HtmlToReactParser from 'html-react-parser';
import { Card, CardHeader, CardTitle } from '../../components/ui/card';
import FourYrPlan from './FourYrPlan';
import { AnimatePresence, motion } from 'framer-motion';
import PublicError from './PublicError';

function MajorDetailTop({
  selectedLevel,
  setSelectedLevel,
  major,
  group,
  academicsArr,
}: {
  selectedLevel: string;
  setSelectedLevel: (level: string) => void;
  major: Major | null;
  group: Major[] | [];
  academicsArr: Academics[];
}) {
  return (
    <AnimatePresence>
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="max-w-[1200px] mx-auto border-transparent border-b-0 rounded-b-none shadow-none mb-10 styled-link"
      >
        <div className="">
          <div className="mb-5 text-center">
            <h1 className="text-5xl font-bold mb-2">{major?.majorTxt}</h1>
            <span className="font-normal text-gray-500 text-lg">
              {major?.collegeTxt}
            </span>
          </div>
          {academicsArr.length !== 0 && (
            <Card className="p-4 xs:p-10">
              <CardHeader className="flex-row items-center justify-between p-0 gap-2">
                <CardTitle className="text-xl xs:text-3xl sm:text-4xl">
                  Learning Objectives
                </CardTitle>
                <FourYrPlan group={group} />
              </CardHeader>
              <Tabs
                onValueChange={(level: string) => {
                  setSelectedLevel(level);
                }}
                value={selectedLevel}
                defaultValue="early"
                className="mt-5"
              >
                <TabsList className="text-slate-100 child:bg-[#888] child:w-[33%] gap-2 bg-white px-0 child:text-sm child:sm:text-md sm:child:px-8 sm:child:py-3 child:py-2 flex items-center child:rounded-md md:child:rounded-sm">
                  <TabsTrigger
                    className="data-[state=active]:shadow-none"
                    value="early"
                  >
                    <span className="hidden xs:inline">Early in the Major</span>
                    <span className="visible xs:hidden">Early</span>
                  </TabsTrigger>
                  <TabsTrigger
                    className="data-[state=active]:shadow-none"
                    value="mid"
                  >
                    <span className="hidden xs:inline">Mid-Major</span>
                    <span className="visible xs:hidden">Mid</span>
                  </TabsTrigger>
                  <TabsTrigger
                    className="data-[state=active]:shadow-none"
                    value="late"
                  >
                    <span className="hidden xs:inline">Late in the Major </span>
                    <span className="visible xs:hidden">Late</span>
                  </TabsTrigger>
                </TabsList>

                {academicsArr?.map((academics: Academics) => {
                  return (
                    <TabsContent key={academics.id} value={academics.level}>
                      {HtmlToReactParser(academics.rtf)}
                    </TabsContent>
                  );
                })}
              </Tabs>
            </Card>
          )}
          {academicsArr.length === 0 && (
            <PublicError
              title="There does not seem to be anything here 👀"
              description="No published content found for this major!"
            />
          )}
        </div>
      </motion.section>
    </AnimatePresence>
  );
}

export default MajorDetailTop;
